import { MenuItem, MenuItemChild } from "@vegi.toenlioe/novitate-react-components";
import {
    Apps as AppsIcon,
    InsertChart as InsertChartIcon,
	Settings as SettingsIcon,
    LockReset as LockResetIcon,
    Logout as LogoutIcon,
    Paid as MoneyIcon,
} from '@mui/icons-material';
import GroupBrgList from "../pages/stock/group_brg/List";
import HargaBarangList from "../pages/sales/harga_barang/List";
import CustomerList from "../pages/sales/customer/List";
import BarangList from "../pages/stock/barang/List";
import KaryawanList from "../pages/global/karyawan/List";
import GudangList from "../pages/stock/gudang/List";
import MenuList from "../pages/global/menu/List";
import Logout from "../pages/Logout";
import { DivisiForm, DivisiList } from "../pages/global/divisi";
import { KategoriBrgForm, KategoriBrgList } from "../pages/stock/kategori_brg";
import Dashboard from "../pages/Dashboard";
import { UserForm, UserList } from "../pages/global/user";
import { PosisiForm, PosisiList } from "../pages/global/posisi";
import { GroupCustForm, GroupCustList } from "../pages/sales/group_cust";
import { SatuanForm, SatuanList } from "../pages/stock/satuan";
import { RoleForm, RoleList } from "../pages/global/role";
import { KaryawanForm } from "../pages/global/karyawan";
import { MenuForm } from "../pages/global/menu";
import { BarangForm } from "../pages/stock/barang";
import { GroupBrgForm } from "../pages/stock/group_brg";
import { GudangForm } from "../pages/stock/gudang";
import { HargaBarangForm } from "../pages/sales/harga_barang";
import { CustomerForm } from "../pages/sales/customer";

export const MenuItems: MenuItem[] = [
	// Profil
	new MenuItem("Profil", "Ubah Password", "Ubah Password", "/change-password", LockResetIcon),
    new MenuItem("Profil", "Logout", "Logout", "/logout", LogoutIcon, Logout),
    // Dashboard
	new MenuItem("Dashboard", "Dashboard", "Dashboard", "/dashboard", InsertChartIcon, Dashboard, false),
	// Umum
	new MenuItem("Umum", "Master", "Master", "/global-masters", AppsIcon, undefined, true, false, [
		new MenuItemChild("GLOBAL-DIVISI", "Divisi", "/divisi", DivisiList, "/divisi/form", DivisiForm, true),
		new MenuItemChild("GLOBAL-POSISI", "Jabatan", "/posisi", PosisiList, "/posisi/form", PosisiForm),
        new MenuItemChild("GLOBAL-KARYAWAN", "Karyawan", "/karyawan", KaryawanList, "/karyawan/form", KaryawanForm),
	]),
	new MenuItem("Umum", "Pengaturan", "Pengaturan", "/global-settings", SettingsIcon, undefined, true, false, [
		new MenuItemChild("GLOBAL-USER-KARYAWAN", "User", "/user", UserList, "/user/form", UserForm, true),
        new MenuItemChild("GLOBAL-ROLE", "Role", "/role", RoleList, "/role/form", RoleForm),
        new MenuItemChild("GLOBAL-MENU", "Menu", "/menu", MenuList, "/menu/form", MenuForm),
	]),
	// Stok
    new MenuItem("Stok", "Master", "Master", "/stock-masters", AppsIcon, undefined, true, false, [
        new MenuItemChild("STOCK-KATEGORI-BRG", "Kategori Barang", "/kategori-barang", KategoriBrgList, "/kategori-barang/form", KategoriBrgForm, true),
        new MenuItemChild("STOCK-GROUP-BRG", "Grup Barang", "/grup-barang", GroupBrgList, "/grup-barang/form", GroupBrgForm),
        new MenuItemChild("STOCK-SATUAN", "Satuan", "/satuan", SatuanList, "/satuan/form", SatuanForm),
        new MenuItemChild("STOCK-BARANG", "Barang", "/barang", BarangList, "/barang/form", BarangForm),
        new MenuItemChild("STOCK-GUDANG", "Gudang", "/gudang", GudangList, "/gudang/form", GudangForm),
	]),
	// Servis
	new MenuItem("Servis", "Master", "Master", "/sales-masters", AppsIcon, undefined, true, false, [
        new MenuItemChild("SERVICE-GROUP-CUSTOMER", "Grup Customer", "/grup-customer", GroupCustList, "/grup-customer/form", GroupCustForm, true),
        new MenuItemChild("SALES-CUSTOMER", "Customer", "/customer", CustomerList, "/customer/form", CustomerForm),
        new MenuItemChild("SERVICE-HARGA-BRG", "Harga Barang", "/harga-barang", HargaBarangList, "/harga-barang/form", HargaBarangForm),
    ]),
	new MenuItem("Servis", "Transaksi", "Transaksi", "/sales-transactions", MoneyIcon, undefined, true, false, [
    ]),
];